<template>
  <div class="ApproveSetting">
    <el-container>
      <el-tabs
        v-model="activeName"
        style="width: 100%"
        @tab-click="handletabClick"
      >
        <el-tab-pane
          :key="index"
          v-for="(item, index) in editableTabs"
          :label="item.value"
          :name="item.label"
        ></el-tab-pane>
      </el-tabs>
      <el-header>
        <el-row>
          <el-form ref="postForm">
            <el-col :span="5" style="margin-right: 20px">
              <el-form-item label="所属组织" prop="orgId">
                <el-select v-model="orgId" @change="changeSelect">
                  <el-option
                    :label="dept.name"
                    :value="dept.id + ''"
                    v-for="dept in GovList"
                    :key="dept.id + ''"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8" v-if="isNeedSubType()">
              <el-form-item label="项目分类" prop="projectId">
                <el-select v-model="projectId">
                  <el-option
                    :label="dept.value"
                    :value="dept.label"
                    v-for="dept in ProjectList"
                    :key="dept.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6" v-if="classList && classList.length > 0">
              <el-form-item label="类型" prop="subType">
                <el-select
                  v-model="subType"
                  filterable
                  default-first-option
                  placeholder="请选择"
                >
                  <el-option
                    :label="item.value"
                    :value="item.label"
                    v-for="item in classList"
                    :key="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col :span="12">
            <div class="handlePanel" >
              <el-button type="primary" @click="manangerStation()"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="addBtnPressed()"
                v-if="btnAuthorize.addBtn.btnEnable"
                >新增审批节点</el-button
              >
              <el-button type="primary" @click="clearStation()">清空节点</el-button>
              <el-button type="primary" @click="editType()" v-if="classList && classList.length > 0">维护类型</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24" style="text-align:left;">
            <div class="operatePanel">
           
               <el-button
                type="primary"
                icon="el-icon-plus"
                @click="saveApprove()"
                v-if="btnAuthorize.addBtn.btnEnable"
              >保存</el-button> 
             </div>
          </el-col>
        </el-row>-->
        <!-- <div style="clear:both;"></div> -->
      </el-header>
      <el-main ref="main" style="width: 80%">
        <el-table
          :data="postionList"
          highlight-current-row
          height="100%"
          width="500px"
          size="mini"
          @current-change="handleSelectionChange"
          border
        >
          <el-table-column
            prop="sortId"
            label="审批顺序"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="jobNames"
            label="审批岗位"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="specialOperate"
            label="允许修改附件"
            :show-overflow-tooltip="true"
          >
           <template slot-scope="scope">
        
              {{ scope.row[scope.column.property]=='MODIFY_ITEM_FOR_CURRENT_NODE'?'是':'否' }}
            
           </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                @click="updateOneApprove(scope.$index, scope.row)"
                type="text"
                size="small"
                >修 改</el-button
              >
              <el-button
                @click="deleteOneApprove(scope.row)"
                type="text"
                size="small"
                >删 除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <!-- 新增/修改弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAdd ? '新增审批流' : '修改审批流'"
      :visible.sync="isAddDialogShow"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="160px"
        :rules="addRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="所属组织">
              <el-select v-model="addForm.orgId" :disabled="true">
                <el-option
                  :label="dept.name"
                  :value="dept.id + ''"
                  v-for="dept in GovList"
                  :key="dept.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="所属岗位" prop="jobId">
              <el-select v-model="addForm.jobIds" multiple @change="$forceUpdate()">
                <el-option
                  :label="post.name"
                  :value="post.id"
                  v-for="post in PostList"
                  :key="post.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

         <el-row>
          <el-col :span="15">
            <el-form-item label="允许修改附件">
               <el-radio-group v-model="addForm.specialOperate" >
                <el-radio
                  v-for="item in options"
                  :label="item.value"
                  :key="item.value"
                  style="width: 160px; margin: 10px 0"
                  :disabled="!(addForm.type=='subContract'||addForm.type=='meetingbill'||addForm.type=='bidmanager')"
                >{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="排序">
              <el-input v-model="addForm.sortId" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="15">
            <el-form-item label="备注">
              <el-input v-model="addForm.remark" autocomplete="off" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isAddDialogShow = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveBtnPressed()">保 存</el-button>
      </div>
    </el-dialog>
    <approveTypeDialog ref="typeDialog"></approveTypeDialog>
  </div>
</template>

<script>
import {
  getApproveTabsService, //获取tab页数据接口
  BasicDataTwoDetailsService, //获取二级数据字典内容
  getApproveListService, //查询审批流
  addApproveService, //保存审批流
  clearApproveService, //清空审批流
  manangerStationService, //获取岗位列表
  getGovService, //组织列表
} from "../../services/sysSettingService";
import {
  getProjectTypeList, //获取项目分类下拉框
} from "../../services/declarationServices";
import approveTypeDialog from "./components/approveTypeDialog.vue";
export default {
  name: "ApproveSetting",
  components:{
    approveTypeDialog
  },
  data() {
    return {
      total: 0, //总数
      orgId: "", //组织id
      projectId: "", //项目分类id
      subType: "", //审批流子分类id
      activeName: "", //活动tab页
      editableTabs: [], //tabs页列表数据
      postionList: [], //审批流列表
      classList: [], //审批流分类列表
      GovList: [], //可选组织列表
      ProjectList: [], //可选项目列表
      PostList: [], //岗位列表
      copyData:[],
      rowIndex: 0, //记录选中行
      isAddDialogShow: false, //新增岗位弹窗显示开关
      isAdd: true, //新增/修改岗位标识
      postSelected: null, //选中的岗位
      selectTabData:{}, //选中得tab页数据
      postform: {
        name: "",
        jobName: "", //岗位名称
        jobId: "", //所属角色
        orgId: "", //所属组织
        sortId: "", //组织id
        type: "", //审批流类型
      },
      addForm: {
        name: "",
        jobName: "", //岗位名称
        jobIds: "", //所属角色
        orgId: "", //所属组织
        sortId: 0, //组织id
        type: "", //审批流类型
        specialOperate:'0',
      },
      options: [
        {
          label: "是",
          value: 'MODIFY_ITEM_FOR_CURRENT_NODE',
        },
        {
          label: "否",
          value: '0',
        },
      ],
      addRules: {
        sortId: [
          { required: true, message: "请输入排序", trigger: "blur" },
          {
            pattern: /(^[0-9]\d*$)/,
            message: "输入内容必须为大于等于0的正整数",
            trigger: "blur",
          },
        ],
        jobIds: [{ required: true, message: "请选择岗位", trigger: "blur" }],
        orgId: [{ required: true, message: "请选择组织", trigger: "blur" }],
        subType: [{ required: true, message: "请选择分类", trigger: "blur" }],
        projectId: [
          { required: true, message: "请选择项目分类", trigger: "blur" },
        ],
      },
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: true },
        modifyBtn: { key: "update", btnEnable: true },
        delBtn: { key: "delete", btnEnable: true },
      },
    };
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  created() {
    this.getTabs();
    this.getUserOneLevelOrg();
    this.getProjectTypeList();
    this.orgId = sessionStorage.getItem("orgId");
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      if (this.$refs.postform) {
        this.$refs.postform.resetFields();
        this.postform.pageIndex = 1;
        this.postform.pageSize = 10;
      }

      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.addForm.orgId = this.orgId;
      this.manangerStation();
      this.getUserOneLevelJob();
    },
    changeSelect(val) {
      this.addForm.orgId = val;
      this.getUserOneLevelJob();
    },
    //获取tab页数据
    getTabs() {
      getApproveTabsService().then(
        (res) => {
          if (res.code == 10000000) {
            this.total = res.total;
            this.editableTabs = res.data;
            this.activeName = res.data[0].label;
            this.selectTabData = res.data[0];
            this.getClassList(res.data[0]); //获取审批流分类列表
            // this.manangerStation();
            // this.addForm.type = res.data[0].label;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 是否需要二级分类 */
    isNeedSubType() {
      if (this.activeName == "meetingbill") {
        return true;
      } else {
        return false;
      }
    },
    /* 获取审批流列表 */
    manangerStation() {
      let param = {
        orgId: this.orgId,
        type: this.activeName,
      };
      //只有包含二级分类的才传subType参数
      if (this.subType) {
        param.subType = this.subType;
      }
      getApproveListService(param).then(
        (res) => {
          if (res.code == 10000000) {
            this.total = res.total;
            this.postionList=[]
            this.copyData=res.data;
            for(let i=0;i< this.copyData.length;i++){
              let item= this.copyData[i]
              if(i>0&& this.copyData[i].sortId== this.copyData[i-1].sortId){
                this.postionList[this.postionList.length-1].jobIds.push(item.jobId)
                this.postionList[this.postionList.length-1].jobNames=this.postionList[this.postionList.length-1].jobNames+','+item.jobName

              }else{
                item.jobIds=[item.jobId]
                item.jobNames=item.jobName
                this.postionList.push(item)
              }
            }
            // this.postionList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },

    //清空审批流
    clearStation() {
      if (this.postionList && this.postionList.length > 0) {
        this.$confirm("确定清空当前所有审批信息?", "提示").then(() => {
          this.postionList = [];
          this.copyData=[]
          this.saveApprove();
        });
      } else {
        this.$message.info("审批流已为空！");
      }
    },

    insertStation() {
      for (let i = 0; i < this.postionList.length; i++) {
        let item = this.postionList[i];
        if (item.sortId == this.addForm.sortId) {
          this.$alert("审批顺序重复，请重新填写！", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      if (this.postionList[0] && this.orgId != this.postionList[0].orgId) {
        this.$alert("不能跨组织修改审批流", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确定保存该条审批信息?", "提示").then(() => {

        this.isAddDialogShow = false;
        // this.postionList[i].name = this.addForm.name;
        // this.postionList[i].orgId = this.addForm.orgId;
        // this.postionList[i].sortId = this.addForm.sortId;
        // this.postionList[i].jobId = this.addForm.jobId;
        // this.postionList[i].type = this.addForm.type;
        // this.postionList[i].roleId = this.addForm.roleId;
        this.addForm.jobIds.forEach(item=>{
          let em={...this.addForm}
          em.jobId=item
          em.jobName=this.PostList.find(e=>e.id==item).name
          delete em.jobIds
          this.copyData.push(em);
        });
       
        this.saveApprove();
        //  this.manangerStation();
      });
    },
    /* 修改岗位信息 */
    modifyStation() {
      for (let i = 0; i < this.postionList.length; i++) {
        let item = this.postionList[i];
        if (i != this.rowIndex) {
          if (item.sortId == this.addForm.sortId) {
            this.$alert("审批顺序重复，请重新填写！", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
      }
      if (this.orgId != this.postionList[0].orgId) {
        this.$alert("不能跨组织修改审批流", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确定修改该条审批信息?", "提示").then(() => {
        let i = this.rowIndex;
         this.copyData= this.copyData.filter(item=>item.sortId!=this.addForm.sortId)
         let data=[...this.addForm.jobIds]
         data.forEach(item=>{
          let em={...this.addForm}
          em.jobId=item
          em.jobName=this.PostList.find(e=>e.id==item).name
          delete em.jobIds
           this.copyData.push(em);
        });

        this.saveApprove();
        //  this.manangerStation();
      });
    },

    /* 查询按钮回调 */
    selectBtnPressed() {
      this.manangerStation();
    },
    /* 重置按钮回调 */
    resetBtnPressed() {
      this.$refs.postform.resetFields();
    },
    //保存审批流
    saveApprove() {
      let reqParam = {};
      let func;
      if (!this.copyData || this.copyData.length == 0) {
        //清空审批流时需要单独调用清空接口
        func = clearApproveService;
        reqParam.orgId = this.orgId;
        reqParam.type = this.activeName;
        reqParam.subType=this.subType
        // if (this.isNeedSubType()) {
        //   reqParam.subType = this.projectId;
        // } else {
        //   delete reqParam.subType;
        // }
      } else {
        //新增和修改复用同一接口，全量数据传参
        func = addApproveService;
        reqParam = this.copyData;
      }

      func(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.isAddDialogShow = false;
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定",
            });
            this.manangerStation();
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    /* 新增按钮回调 */
    addBtnPressed() {
      this.isAdd = true;
      this.isAddDialogShow = true;
      if (this.addForm != null) {
        this.addForm.name = "";
        this.addForm.jobIds = [];
        this.addForm.sortId = this.postionList.length + 1;
        this.addForm.orgId = this.orgId;
        this.addForm.type = this.activeName;
        this.addForm.subType = this.subType; 
         this.addForm.specialOperate='0';

      }
    },
    //维护类型
    editType(){
      this.$refs.typeDialog.showDialogFun(this.selectTabData)
    },
    /* 修改按钮回调 */
    updateOneApprove(index, row) {
      this.isAdd = false;
      this.isAddDialogShow = true;
      this.addForm = row;
      this.addForm.jobIds=[]
      this.addForm.jobIds =this.copyData.filter(item=>item.sortId==row.sortId).map(em => em.jobId)
      this.addForm.orgId = row.orgId + "";
      this.rowIndex = index;
      // this.addForm.jobIds = row.jobId.split(',');
    },
    /* 删除按钮回调 */
    deleteOneApprove(row) {
      let _this = this;
      this.$confirm("确定删除该条审批信息?", "提示").then(() => {
         let sortIdindex = 0;
        for (let i = 0; i < _this.copyData.length; i++) {
          if (_this.copyData[i].sortId == row.sortId) {
            sortIdindex = i;
            break;
          }
        }
        this.copyData= this.copyData.filter(item=>item.sortId!=row.sortId)
        for (let i = sortIdindex; i < _this.copyData.length; i++) {
          _this.copyData[i].sortId = _this.copyData[i].sortId-1;
        }
        _this.saveApprove();
      });
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (this.isAdd) {
            this.insertStation();
          } else {
            this.modifyStation();
          }
        }
      });
    },

    /* 列代表单选回调 */
    handleSelectionChange(post) {
      this.postSelected = post;
      if (post != null) {
        this.$nextTick(() => {
          this.addForm = Object.assign({}, post);
        });
      }
    },
    /* 获取新增角色时可选组织 */
    getUserOneLevelOrg() {
      let reqParam = {
        pageIndex: 1,
        pageSize: 100,
      };
      getGovService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    /* 获取项目分类列表 */
    getProjectTypeList() {
      getProjectTypeList().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.ProjectList = res.data;
            //默认选中第一个分类
            if (res.data && res.data.length > 0) {
              this.projectId = res.data[0].label;
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //tab页切换
    handletabClick(tab, event) {
      this.activeName = tab.name;
      this.addForm.type = tab.name;
      this.editableTabs.forEach((item, index) => {
        if (item.label === this.activeName) {
          this.selectTabData = item;
        }
      });
      this.getClassList(this.selectTabData); //获取审批流分类列表
    },
    //获取当前审批流分类下拉框数据
    getClassList(item) {
      let params = {};
      // params.dictId = this.dictId;
      params.pid = item.id||'';
      BasicDataTwoDetailsService(params)
        .then((res) => {
          if (res.code == 10000000) {
            this.classList = res.data;
            this.subType = res.data[0]?.label ?? "";
            this.manangerStation();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        }).finally(()=>{
         
        });
    },
    //获取审批流岗位下拉列表
    getUserOneLevelJob() {
      let reqParam = {
        orgId: this.addForm.orgId,
        pageIndex: 1,
        pageSize: 100,
      };
      manangerStationService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.PostList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.ApproveSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
/deep/.el-col-8 {
  width: 30%;
}
</style>
